import React from 'react';
import { NavBar } from '../components/ui/NavBar';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { AuthoritySection } from '../components/sections/AuthoritySection';
import { ServicesSection } from '../components/sections/ServicesSection';
import { DifferentiationSection } from '../components/sections/DifferentiationSection';
import { CaseStudiesSection } from '../components/sections/CaseStudiesSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-emerald-100 selection:text-emerald-900" data-id="element-186" data-mp="2kxp7kbjx1a22">
      <NavBar data-id="element-187" data-mp="2g0f8032tbi0i" />
      <main data-id="element-188" data-mp="2fxkr2lj0cfbu">
        <HeroSection data-id="element-189" data-mp="qkpkxyh4bfla" />
        <ProblemSection data-id="element-190" data-mp="qk7fqcch9r18" />
        <AuthoritySection data-id="element-191" data-mp="qlikaedqz2te" />
        <ServicesSection data-id="element-192" data-mp="qmtmi9rjo2ie" />
        <DifferentiationSection data-id="element-193" data-mp="llw53zeczchy" />
        <CaseStudiesSection data-id="element-194" data-mp="lmo1hcfs5e9a" />
        <FinalCTASection data-id="element-195" data-mp="lngz9nwrgtfa" />
      </main>

      <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-196" data-mp="2zj6w8xo6nb21">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-197" data-mp="33kihys3xrc4y">
          <div className="mb-4 md:mb-0" data-id="element-198" data-mp="38j3kwzako9x3">
            <span className="text-xl font-bold" data-id="element-199" data-mp="38iaigainc6kr">
              <span style={{
              color: '#ffffff'
            }} data-id="element-200" data-mp="3davap7lwmbm6">
                Pen
              </span>
              <span style={{
              color: '#059669'
            }} data-id="element-201" data-mp="3ibizrnqkoidr">
                Point
              </span>
              
            </span>
          </div>
          <div className="text-sm" data-id="element-202" data-mp="3r80fz5dsn6gd">
            &copy; {new Date().getFullYear()} All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}